export const siteConfig = {
  name: 'UltimateCheckers',
  title: 'UltimateCheckers — Play Checkers Online',
  description:
    'Play checkers online for free. Fast, modern, and mobile-friendly checkers with no sign-up required.',
  url: 'https://www.ultimatecheckers.com',
  ogImage: '/og-image.png',
  locale: 'en_US',
  twitterHandle: '@ultimatecheckers',
} as const

export type SiteConfig = typeof siteConfig
